import React from "react";
import styled from "styled-components";

import largeIconSet from "../../../assets/images/largeIconSet.png";

const OnboardingLayoutStyle = styled.main`
  // background: #0D024E;
  // padding-top: 100px;
  // padding-bottom: 100px;
  display: flex;
  // flex-direction: column;
  // align-items: center;
  // min-height: 100vh;
`;
export const OnboardingLayout = (props) => {
  return (
    <OnboardingLayoutStyle className="">
      <div
        className="w-1/3 hidden md:flex flex-col items-end justify-end h-screen"
        style={{ background: "#0E1D45" }}
      >
        <img src={largeIconSet} alt="" className="" style={{ maxHeight: "100vh" }} />
      </div>
      <div className="w-full md:w-2/3">{props.children}</div>
    </OnboardingLayoutStyle>
  );
};
